<template>
  <div>感谢您回答本次调查问卷</div>
</template>

<script>
export default {
  name: 'aspx.vue',
  data() {
    return {
      form:{
        param:this.$router.currentRoute.query.sojumpparm ? this.$router.currentRoute.query.sojumpparm.split(';')[0] : '',
        code:this.$router.currentRoute.query.sojumpparm ? this.$router.currentRoute.query.sojumpparm.split(';')[1] : ''
      }
    }
  },
  mounted() {
    console.log('form',this.form)
    this.getCenter();
  },
  methods:{
    getCenter() {
      this.$api.resultUpload(this.form)
    }
  }
}
</script>

<style scoped>

</style>
